import { render } from "./pitch-image.vue?vue&type=template&id=0d572bb2&scoped=true&ts=true"
import script from "./pitch-image.vue?vue&type=script&lang=ts"
export * from "./pitch-image.vue?vue&type=script&lang=ts"

import "./pitch-image.vue?vue&type=style&index=0&id=0d572bb2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d572bb2"]])

export default __exports__